import { AuthenticatedRoute } from "../routes/ProtectedRoutes.tsx";
import { PlaceProvider } from "../providers/PlaceProvider.tsx";
import { CampaignProvider } from "../views/Campaign/CampaignContext.tsx";
import { StatsProvider } from "../providers/StatsProvider.tsx";
import { ToDoProvider } from "../providers/ToDoProvider.tsx";
import { GoogleInsightsProvider } from "../views/GooglePerformance/GoogleInsightsProvider.tsx";
import Layout from "../views/Layout/Layout.tsx";
import SuspenseContainer from "../components/SuspenseContainer/SuspenseContainer.tsx";
import { Outlet } from "react-router-dom";

export const AppLayout = () => (
  <AuthenticatedRoute>
    <PlaceProvider>
      {/* Above ToDoProvider on purpose: ToDoProvider reads keyword-setup and
          keyword-insights/history from this context instead of fetching them
          a second time. */}
      <GoogleInsightsProvider>
        <CampaignProvider>
          <StatsProvider>
            <ToDoProvider>
              <Layout>
                <SuspenseContainer>
                  <Outlet />
                </SuspenseContainer>
              </Layout>
            </ToDoProvider>
          </StatsProvider>
        </CampaignProvider>
      </GoogleInsightsProvider>
    </PlaceProvider>
  </AuthenticatedRoute>
);
